<template>
  <CRow class="">
    <template v-if="!isPrint">
      <CCol v-if="activeScheduling">
        <CRow class="align-items-center background-indicadores" style="height: 60px">
          <CCol sm="4" class="pl-3 d-flex">
            <p class="d-flex align-self-center mb-0">
              <CIcon name="emailFull" :height="25" viewBox="0 0 32 32" class="mr-2" />
              <span class="font-2xl">
                {{ activeScheduling.totalRecipientsCount }}
              </span>
              <span class="text-gray-800 font-1xl ml-2">{{ $t('campaign.campaignResult.dashboard.emailEngagement.text.emailSent') }}</span>
            </p>
          </CCol>
          <CCol sm="3" class="pl-3 d-flex">
            <p class="d-flex align-self-center mb-0 hover-link" @click="goToResume('recipients')">
              <CIcon name="userBgFull" :height="25" viewBox="0 0 32 32" class="mr-2 text-gray-600" />
              <span class="font-2xl">
                {{ activeScheduling.totalRecipientsCount }}
              </span>
              <span class="text-gray-800 font-1xl ml-2">{{ $t('campaign.campaignResult.dashboard.emailEngagement.text.recipients') }}</span>
            </p>
          </CCol>
          <CCol sm="3">
            <div class="sent-date">
              {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.sentOn') }}
              {{ formatDateTimeFull(activeScheduling.schedulingDatetime) }}
              ({{ activeScheduling.timezone }})
            </div>
          </CCol>
          <CCol sm="2" v-if="countPages > 1">
            <CustomPagination class="align" :activePage.sync="activePage" :countPages="countPages" />
          </CCol>
        </CRow>

        <CRow class="border-line-bottom">
          <CCol sm="3" class="border-line-right pt-5">
            <div class="font-weight-semi-bold sent-date">
              {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.sender') }}
            </div>
            <div class="mb-4">
              {{ activeScheduling.senderName }}
            </div>
            <div class="font-weight-semi-bold sent-date">
              {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.email') }}
            </div>
            <div class="scroll-area-message mt-2">
              <figure class="img-crop d-flex align-items-center m-0">
                <img
                  v-if="activeScheduling.templateId"
                  :src="`${$configs.VUE_APP_ROOT_API}template/email/static/${activeScheduling.templateId}/thumbnail.jpg`"
                  alt=""
                  width="400"
                  height="auto"
                  @click.stop="openModal(item)"
                />
              </figure>
            </div>
          </CCol>
          <CCol>
            <CRow>
              <CCol sm="7" class="pt-5 pl-5 pr-2">
                <CRow>
                  <CCol>
                    <apexchart type="radialBar" :options="chartOptionsSuccess" :series="seriesUniqueOpen" width="160"></apexchart>
                    <div class="pl-4">
                      <a @click="goToResume('uniqueopens')" class="text-blue link-clickable">{{
                        $t('campaign.campaignResult.dashboard.emailEngagement.link.uniqueOpen')
                      }}</a>
                      <div class="mt-2 individual-engagement">
                        {{ activeScheduling.performance.uniqueOpenCount }}
                      </div>
                      <div class="text-gray-600 mt-1">
                        {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.email') }}
                      </div>
                    </div>
                  </CCol>
                  <CCol>
                    <apexchart type="radialBar" :options="chartOptionsSuccess" :series="seriesUniqueClick" width="160"></apexchart>
                    <div class="pl-4">
                      <a @click="goToResume('clicks')" class="text-blue link-clickable">{{
                        $t('campaign.campaignResult.dashboard.emailEngagement.link.uniqueClicks')
                      }}</a>
                      <div class="mt-2 individual-engagement">
                        {{ activeScheduling.performance.uniqueClickCount }}
                      </div>
                      <div class="text-gray-600 mt-1">
                        {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.email') }}
                      </div>
                    </div>
                  </CCol>
                  <CCol>
                    <apexchart type="radialBar" :options="chartOptionsWarning" :series="seriesBounced" width="160"> </apexchart>
                    <div class="pl-4">
                      <a @click="goToResume('bounced')" class="text-orange link-clickable">{{
                        $t('campaign.campaignResult.dashboard.emailEngagement.link.bounced')
                      }}</a>
                      <div class="mt-2 individual-engagement">
                        {{ activeScheduling.performance.bouncedCount }}
                      </div>
                      <div class="text-gray-600 mt-1">
                        {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.email') }}
                      </div>
                    </div>
                  </CCol>
                  <CCol>
                    <apexchart type="radialBar" :options="chartOptionsWarning" :series="seriesUnsubscribed" width="160"></apexchart>
                    <div class="pl-4">
                      <a @click="goToResume('unsubscribes')" class="text-orange link-clickable">{{
                        $t('campaign.campaignResult.dashboard.emailEngagement.link.unsubscribed')
                      }}</a>
                      <div class="mt-2 individual-engagement">
                        {{ activeScheduling.performance.unsubscribeCount ? activeScheduling.performance.unsubscribeCount : 0 }}
                      </div>
                      <div class="text-gray-600 mt-1">
                        {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.email') }}
                      </div>
                    </div>
                  </CCol>
                </CRow>

                <CRow class="mt-4">
                  <div class="pl-4">
                    <a @click="goToResume('markedasspam')" class="text-span link-clickable"
                      >{{ activeScheduling.performance.markedAsSpamCount }}
                      {{ $t('campaign.campaignResult.dashboard.emailEngagement.link.emailsToSpam') }}</a
                    >
                  </div>
                </CRow>
              </CCol>
              <CCol sm="5" class="pt-5">
                <div class="font-weight-semi-bold sent-date px-2">
                  {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.topLocations') }}
                </div>
                <div class="scroll-area-message mt-2 px-3">
                  <div v-for="(country, index) in activeSchedulingSortedByLocationOpen" :key="index">
                    <CRow>
                      <CCol sm="2" style="padding-right: 0px" class="text-right">
                        <img :src="getFlag(country.countryId)" width="30" />
                      </CCol>
                      <CCol sm="4" class="text-gray-600">
                        {{ country.countryId ? country.countryId : $t('components.toplocatinos.Unknown') }}
                      </CCol>
                      <CCol sm="3" class="text-gray-600 text-right">
                        {{ country.count }}
                      </CCol>
                      <CCol sm="3" class="text-gray-base"> {{ topLocationPercent(activeScheduling, country.count) }}% </CCol>
                    </CRow>
                    <hr class="mt-1" />
                  </div>
                </div>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCol>
    </template>
    <template v-if="isPrint">
      <CRow class="email__section">
        <CCol>
          <h3 class="font-weight-normal p-4">EMAIL</h3>
        </CCol>
        <CCol sm="12" class="mt-2 email__item" v-for="(item, index) in emailSchedulingSortedByLocation" :key="index" :class="{ isPrint: isPrint }">
          <CCol>
            <CRow class="align-items-center background-indicadores" style="height: 70px">
              <CCol sm="4" class="pl-3 d-flex">
                <p class="total-sent d-flex align-self-center mb-0" >
                  <CIcon name="smsFull" size="custom-size" :height="18" viewBox="0 0 32 32" class="mr-3" />
                  {{ item.totalRecipientsCount }}
                  <span class="total-sent-msg font-sm ml-2">{{ $t('campaign.campaignResult.dashboard.emailEngagement.text.emailSent') }}</span>
                </p>
              </CCol>
              <CCol sm="3" class="pl-3 d-flex">
                <p class="total-recipients d-flex align-self-center mb-0">
                  <CIcon name="userBgFull" size="custom-size" :height="22" viewBox="0 0 32 32" class="mr-2" />
                  {{ item.totalRecipientsCount }}
                  <span class="total-sent-msg font-sm ml-2">{{ $t('campaign.campaignResult.dashboard.emailEngagement.text.recipients') }}</span>
                </p>
              </CCol>
              <CCol sm="3">
                <div class="sent-date">
                  {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.sentOn') }}
                  {{ formatDateTimeFull(new Date(item.schedulingDatetime).toISOString()) }}
                </div>
              </CCol>
            </CRow>
            <CRow class="border-line-bottom">
              <CCol sm="3" class="border-line-right pt-5">
                <div class="font-weight-semi-bold sent-date">{{ $t('campaign.campaignResult.dashboard.emailEngagement.text.email') }}</div>
                <div class="scroll-area-message mt-2">
                  <!-- `${this.$configs.VUE_APP_ROOT_API}template/email/static/${this.template.templateId}/thumbnail.jpg` -->
                  <figure class="img-crop d-flex align-items-center m-0">
                    <img
                      v-if="activeScheduling.templateId"
                      :src="`${$configs.VUE_APP_ROOT_API}template/email/static/${item.templateId}/thumbnail.jpg`"
                      alt=""
                      width="400"
                      height="auto"
                      @click.stop="openModal(item)"
                    />
                  </figure>
                </div>
              </CCol>
              <CCol>
                <CRow>
                  <CCol sm="7" class="pt-5 pl-5 pr-2">
                    <CRow>
                      <CCol>
                        <apexchart type="radialBar" :options="chartOptionsSuccess" :series="seriesUniqueOpen" width="160"></apexchart>
                        <div class="pl-4">
                          <a @click="goToResume('uniqueopens')" class="text-blue link-clickable">{{
                            $t('campaign.campaignResult.dashboard.emailEngagement.link.uniqueOpen')
                          }}</a>
                          <div class="mt-2 individual-engagement">
                            {{ item.performance.uniqueOpenCount }}
                          </div>
                          <div class="text-gray-600 mt-1">
                            {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.email') }}
                          </div>
                        </div>
                      </CCol>
                      <CCol>
                        <apexchart type="radialBar" :options="chartOptionsSuccess" :series="seriesUniqueClick" width="160"></apexchart>
                        <div class="pl-4">
                          <a @click="goToResume('clicks')" class="text-blue link-clickable">{{
                            $t('campaign.campaignResult.dashboard.emailEngagement.link.clicks')
                          }}</a>
                          <div class="mt-2 individual-engagement">
                            {{ item.performance.clickCount }}
                          </div>
                          <div class="text-gray-600 mt-1">
                            {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.email') }}
                          </div>
                        </div>
                      </CCol>
                      <CCol>
                        <apexchart type="radialBar" :options="chartOptionsWarning" :series="seriesBounced" width="160"> </apexchart>
                        <div class="pl-4">
                          <a @click="goToResume('bounced')" class="text-orange link-clickable">{{
                            $t('campaign.campaignResult.dashboard.emailEngagement.link.bounced')
                          }}</a>
                          <div class="mt-2 individual-engagement">
                            {{ item.performance.bouncedCount }}
                          </div>
                          <div class="text-gray-600 mt-1">
                            {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.email') }}
                          </div>
                        </div>
                      </CCol>
                      <CCol>
                        <apexchart type="radialBar" :options="chartOptionsWarning" :series="seriesUnsubscribed" width="160"></apexchart>
                        <div class="pl-4">
                          <a @click="goToResume('unsubscribes')" class="text-orange link-clickable">{{
                            $t('campaign.campaignResult.dashboard.emailEngagement.link.unsubscribed')
                          }}</a>
                          <div class="mt-2 individual-engagement">
                            {{ item.performance.unsubscribeCount ? item.performance.unsubscribeCount : 0 }}
                          </div>
                          <div class="text-gray-600 mt-1">
                            {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.email') }}
                          </div>
                        </div>
                      </CCol>
                    </CRow>

                    <CRow class="mt-4">
                      <div class="pl-4">
                        <a @click="goToResume('markedasspam')" class="text-span link-clickable"
                          >{{ item.performance.markedAsSpamCount }} {{ $t('campaign.campaignResult.dashboard.emailEngagement.link.emailsToSpam') }}</a
                        >
                      </div>
                    </CRow>
                  </CCol>
                  <CCol sm="5" class="pt-5">
                    <div class="font-weight-semi-bold sent-date px-2">
                      {{ $t('campaign.campaignResult.dashboard.emailEngagement.text.topLocations') }}
                    </div>
                    <div class="scroll-area-message mt-2 px-3">
                      <div v-for="(country, index) in item.performance.topLocations.open" :key="index">
                        <CRow>
                          <CCol sm="2" style="padding-right: 0px" class="text-right">
                            <img :src="getFlag(country.countryId)" width="30" />
                          </CCol>
                          <CCol sm="4" class="text-gray-600">
                            {{ country.countryId }}
                          </CCol>
                          <CCol sm="3" class="text-gray-600 text-right">
                            {{ country.count }}
                          </CCol>
                          <CCol sm="3" class="text-gray-base"> {{ topLocationPercent(item, country.count) }}% </CCol>
                        </CRow>
                        <hr class="mt-1" />
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CCol>
      </CRow>
    </template>
  </CRow>
</template>

<script>
import { dateFormatStringFull } from '@/utils/dateUtil.js'
import VueApexCharts from 'vue-apexcharts'
import countries from '../../../../../countriesList'
import CustomPagination from '@/components/CustomPagination'

export default {
  props: {
    campaignResult: Object,
    isPrint: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    apexchart: VueApexCharts,
    CustomPagination,
  },
  data() {
    return {
      activePage: 1,
      scheduling: null,
      seriesUniqueOpen: [0],
      seriesUnsubscribed: [0],
      seriesUniqueClick: [0],
      seriesBounced: [0],
      chartOptionsSuccess: {
        chart: {
          type: 'radialBar',
          offsetY: -15,
          offsetX: -25,
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          radialBar: {
            track: {
              background: '#e7e7e7',
              strokeWidth: '98%',
              margin: 15,
              dropShadow: {
                enabled: false,
                top: 2,
                left: 0,
                color: '#999',
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: 6,
                fontSize: '20px',
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        fill: {
          type: 'solid',
        },
        labels: [''],
        colors: ['#6ebff3'],
      },
      chartOptionsWarning: {
        chart: {
          type: 'radialBar',
          offsetY: -15,
          offsetX: -25,
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          radialBar: {
            track: {
              background: '#e7e7e7',
              strokeWidth: '98%',
              margin: 15,
              dropShadow: {
                enabled: false,
                top: 2,
                left: 0,
                color: '#999',
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: 6,
                fontSize: '20px',
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        fill: {
          type: 'solid',
        },
        labels: [''],
        colors: ['#ee9200'],
      },
    }
  },
  computed: {
    countPages: function () {
      if (this.campaignResult.channels) {
        return this.campaignResult.channels.email.schedulings.length
      }
      return 0
    },
    activeScheduling: function () {
      if (this.campaignResult.channels) {
        return this.campaignResult.channels.email.schedulings[this.activePage - 1]
      }
      return null
    },
    activeSchedulingSortedByLocationOpen() {
      return this.activeScheduling.performance.topLocations.open.sort((a, b) => b.count - a.count)
    },
    emailSchedulingSortedByLocation() {
      return this.campaignResult.channels.email.schedulings.map((items) => {
        return {
          ...items,
          performance: {
            topLocations: {
              open: items.performance.topLocations.open.sort((a, b) => b.count - a.count),
            },
          },
        }
      })
    },
  },
  methods: {
    formatDateTimeFull(date) {
      return dateFormatStringFull(date)
    },
    getFlag(key) {
      return countries.find((elm) => {
        return elm.code === key
      })?.flag
    },
    goToResume(type) {
      this.$router.push({
        name: 'campaignResume',
        params: {
          campaignId: this.$route.params.campaignId,
          scheduleType: 'email',
          scheduleId: this.activeScheduling.schedulingId,
          type: type,
        },
      })
    },
    calculatingPercent() {
      if (this.activeScheduling && this.activeScheduling.performance && this.activeScheduling.totalRecipientsCount > 0) {
        let totalRecipientsCount = isNaN(this.activeScheduling.totalRecipientsCount) ? 0 : this.activeScheduling.totalRecipientsCount
        let uniqueClickCount = isNaN(this.activeScheduling.performance.uniqueClickCount) ? 0 : this.activeScheduling.performance.uniqueClickCount
        let uniqueOpen = isNaN(this.activeScheduling.performance.uniqueOpenCount) ? 0 : this.activeScheduling.performance.uniqueOpenCount
        let bouncedCount = isNaN(this.activeScheduling.performance.bouncedCount) ? 0 : this.activeScheduling.performance.bouncedCount
        let unsubscribeCount = isNaN(this.activeScheduling.performance.unsubscribeCount) ? 0 : this.activeScheduling.performance.unsubscribeCount

        this.seriesUniqueOpen = [totalRecipientsCount > 0 ? Math.round((uniqueOpen * 100) / totalRecipientsCount) : 0]
        this.seriesUniqueClick = [uniqueOpen > 0 ? Math.round((uniqueClickCount * 100) / uniqueOpen) : 0]
        this.seriesBounced = [totalRecipientsCount > 0 ? Math.round((bouncedCount * 100) / totalRecipientsCount) : 0]
        this.seriesUnsubscribed = [totalRecipientsCount > 0 ? Math.round((unsubscribeCount * 100) / totalRecipientsCount) : 0]

        this.reloadShart = false
        this.$nextTick(() => {
          this.reloadShart = true
        })
      }
    },

    // seriesUniqueOpenItem(item) {
    //   if (item && item.performance && item.totalRecipientsCount > 0) {
    //     this.seriesUniqueOpen = [Math.round((item.performance.uniqueOpenCount * 100) / item.totalRecipientsCount)]
    //     this.seriesUniqueClick = [Math.round((item.performance.clickCount * 100) / item.totalRecipientsCount)]
    //     this.seriesBounced = [Math.round((item.performance.bouncedCount * 100) / item.totalRecipientsCount)]
    //     this.seriesUnsubscribed = [Math.round((item.performance.unsubscribeCount * 100) / item.totalRecipientsCount)]

    //     this.reloadShart = false
    //     this.$nextTick(() => {
    //       this.reloadShart = true
    //     })
    //   }
    // },

    topLocationPercent(item, value) {
      let result = 0
      if (item && item.performance && item.performance.openCount > 0) {
        result = Math.round((value * 100) / item.performance.openCount)
      }
      // if (item && item.performance && item.totalRecipientsCount > 0) {
      //   result = Math.round((value * 100) / item.totalRecipientsCount)
      // }
      return result > 100 ? 100 : result
    },
  },
  watch: {
    activeScheduling: function (newSchedule) {
      if (newSchedule) {
        this.calculatingPercent()
      }
    },
  },
  mounted() {
    this.calculatingPercent()
  },
}
</script>

<style lang="scss" scope>
.hover-link {
  &:hover {
    color: var(--primary);
    cursor: pointer;
  }
}
.border-line-bottom {
  border-bottom: 1px solid $gray-500;
}
.border-line-right {
  border-right: 1px solid $gray-500;
}

.text-blue {
  color: #6ebff3 !important;
}

.text-orange {
  color: #ee9200 !important;
}

.link-clickable {
  text-decoration: underline !important;
  font-size: $font-size-xs1;
  cursor: pointer;
}

.text-span {
  color: $gray-600 !important;
  font-weight: 600;
}

.total-sent {
  font-size: $font-size-xl;
  color: $gray-base;
  font-weight: 200;
}

.total-sent-msg {
  font-size: $font-size-base;
  color: $gray-600;
  font-weight: 500;
}

.sent-date {
  font-size: $font-size-base;
  color: $gray-600;
  font-weight: 500;
}

.page-active {
  color: $gray-700;
  font-weight: 600;
}

.scroll-area-message {
  overflow-y: hidden;

  min-height: 270px;
}

.individual-engagement {
  font-size: $font-size-md;
  color: $gray-700;
}

.background-indicadores {
  background-color: $gray-200;

  icon {
    fill: $gray-300;
  }
}
</style>
